import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject, isObservable, of } from 'rxjs';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import {
  HeadMenuService,
  IMenuDropDownItem,
  IMenuItem,
} from './head-menu.service';

import { TranslateService } from '@ngx-translate/core';
import { SDKService } from '../sdk.service';
import { WhiteLabelService } from '../shared/services/whitelabel.service';

@Component({
  selector: 'app-head',
  templateUrl: 'head.component.html',
  styleUrls: ['head.component.css'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('menuState', [
      state(
        'open',
        style({
          height: '100%',
        }),
      ),
      state(
        'closed',
        style({
          height: '50px',
        }),
      ),
      transition('closed => open', animate('150ms ease-in')),
      transition('open => closed', animate('150ms ease-out')),
    ]),
  ],
})
export class HeadComponent implements OnInit, OnDestroy {
  isCollapsed: boolean;
  menuItems$: Observable<any[]>;
  menuState: string;
  screenWidth: number;
  namespace: string;
  isMenuHidden: Observable<boolean>;
  private onDestroy$: Subject<void> = new Subject();

  constructor(
    public headMenuService: HeadMenuService,
    public WL: WhiteLabelService,
    private cdr: ChangeDetectorRef,
    private sdkService: SDKService,
    private translate: TranslateService,
  ) {
    this.isCollapsed = true;
    this.isMenuHidden = this.sdkService.isHeadMenuHidden$.pipe(
      takeUntil(this.onDestroy$),
    );
  }

  getNS(link: IMenuItem, subLink?: IMenuDropDownItem): string {
    if (!link.namespace) return;
    if (subLink && !subLink.namespace) return;

    let namespace = this.namespace ?? '';
    namespace += link.namespace ? `.${link.namespace}` : '';
    namespace += subLink?.namespace ? `.${subLink.namespace}` : '';
    return namespace;
  }

  ngOnInit(): void {
    // this.menuItems$ = combineLatest([
    //   this.headMenuService.namespace,
    //   this.translate.onLangChange,
    // ]).pipe(
    //   switchMap(([ns]) => {
    this.menuItems$ = this.headMenuService.namespace.pipe(
      switchMap((ns) => {
        this.namespace = `${ns}.head-menu`;
        return this.headMenuService.items;
      }),
      map((items: any[]) => {
        // Position first and last items left and right
        const first = items[0];
        const last = items[items.length - 1];

        if (first && !!first.dropdown && !first.placement) {
          first.placement = 'bottom-left';
        }

        if (last && !!last.dropdown && !last.placement) {
          last.placement = 'bottom-right';
        }

        return this.convertItemClassesToObservables(items);
      }),
      takeUntil(this.onDestroy$),
    );
  }

  convertItemClassesToObservables(items) {
    return items.map((item) => {
      item.class = isObservable(item.class) ? item.class : of(item.class);
      if (item.dropdown) {
        item.dropdown = this.convertItemClassesToObservables(item.dropdown);
      }
      return item;
    });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  isHidden(
    param?: boolean | Function | Observable<boolean>,
  ): Observable<boolean> {
    switch (typeof param) {
      case 'function':
        return of(param());

      case 'boolean':
        return of(param);

      case 'undefined':
        return of(param);

      default:
        return param;
    }
  }
}
